"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormOfAddress = void 0;
var FormOfAddress;
(function (FormOfAddress) {
    FormOfAddress["Empty"] = "";
    FormOfAddress["Male"] = "male";
    FormOfAddress["Female"] = "female";
    FormOfAddress["Divers"] = "other";
})(FormOfAddress = exports.FormOfAddress || (exports.FormOfAddress = {}));
//# sourceMappingURL=form-of-address.js.map